// Maps the raw 0..5 score from usePasswordStrength (one point per passed
// check: lower, upper, digit, special, length) to the three severity bands
// the UI uses. Keeping this out of the component so it stays unit-testable
// without a React renderer; this project doesn't ship @testing-library/react.
export const strengthStatus = (score) => {
  if (score === 1 || score === 2) {
    return { label: "słabe", severity: "weak" };
  }
  if (score === 3 || score === 4) {
    return { label: "średnie", severity: "medium" };
  }
  if (score === 5) {
    return { label: "silne", severity: "strong" };
  }
  return { label: null, severity: null };
};
